import React, { Component } from 'react';
import Modal from 'react-modal';
import LocalizedMessage from '../../common/LocalizedMessage';

import {Table, Button }
    from 'react-bootstrap';
import { connect }
    from 'react-redux';

import { Link } from 'react-router-dom';
const customStyles = {
    content: {
        top: '40%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        width: '1400px',
        maxWidth: '1500px',
        padding: '0',
        border: '0',
        background: ''
    }
};

Modal.setAppElement('#root');
Modal.defaultStyles.overlay.backgroundColor = 'rgba(0,0,0,0.5)';
Modal.defaultStyles.overlay.zIndex = '1050';

class ChengeHistoryModal extends Component {



    state = {
        modalIsOpen: false,
        customerID: '',
        name: ''
    }

    componentDidMount() {
        this.props.onRef(this);
    }

    componentWillUnmount() {
        this.props.onRef(null)
    }


    openModal = () => {


        this.setState({ modalIsOpen: true });

    }


    closeModal = () => {
        this.setState({ modalIsOpen: false });

        window.location.reload();
    }



    render() {
        return (
            <div>
                <Modal
                    isOpen={this.state.modalIsOpen}
                    onRequestClose={this.closeModal}
       
                    contentLabel="Example Modal"
                >
                    <div id="myModal">
                        <div className="modal-dialog modal-animations">
                            <div className="modal-content pl-4 pr-4 pb-0">
                                <div className="modal-header">

                                <h5>পরিবর্তক : <strong className="text-center">সাগর সৌরভ রায় </strong> </h5>
                                    {/* <strong className="modal-title">Delete</strong> */}
                                    {/* <button type="button" className="close" onClick={this.closeModal}>×</button> */}
                                </div>
                                <div className="modal-body">
                                <Table responsive striped bordered hover size="sm">
                                <thead>
                                    <tr>
                                        <th>তারিখ </th>
                                        <th>রশিদ নং</th>
                                        <th>সদস্য নম্বর</th>
                                        <th>সদস্য /সদস্যার নাম </th>
                                        <th>শেয়ার </th>
                                        <th>সঞ্চয়  </th>
                                        <th>শিশু সঞ্চয় </th>
                                        <th> শিক্ষা সঞ্চয়</th>
                                        <th>চিকৎসা সঞ্চয় </th>
                                        <th>দৈনিক সঞ্চয় </th>
                                        <th>ঋণ নং</th>
                                        <th>আসল </th>
                                        <th>সেবা মূল্য </th>
                                        <th>কিস্তি নং </th>
                                        <th>জরিমানা </th>
                                        <th>ফর্ম/ পাশ বই বিক্রয় </th>
                                        <th>তহবিল </th>
                              

                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>১/১/২০২০</td>
                                        <td>৫</td>
                                        <td>২০০</td>
                                        <td>সাগর সৌরভ রায় </td>
                                        <td><del>২৫২.00</del> </td>
                                        <td>২৫২.00 </td>
                                        <td>২৫২.00 </td>
                                        <td>২৫২.00 </td>
                                        <td>২৫২.00 </td>
                                        <td>২৫২.00 </td>
                                        <td>২৫২.00 </td>
                                        <td>২৫২৯৯ </td>
                                        <td>২৫.২৯ </td>
                                        <td>২৯ </td>
                                        <td>২৫৯.২৯ </td>
                                        <td>২৫৯.২৯ </td>
                                        <td>২৫৯.২৯ </td>
                               

                                    </tr>
                                    <tr>
                                        <td>১/১/২০২০</td>
                                        <td>৫</td>
                                        <td>২০০</td>
                                        <td>সাগর সৌরভ রায় </td>
                                        <td>৫৯.00 </td>
                                        <td><del>২৫২.00 </del></td>
                                        <td><del>২৫২.00 </del></td>
                                        <td><del>২৫২.00 </del></td>
                                        <td><del>২৫২.00 </del></td>
                                        <td><del>২৫২.00 </del></td>
                                        <td><del>২৫২.00 </del></td>
                                        <td><del>২৫২৯৯ </del></td>
                                        <td><del>২৫.২৯ </del></td>
                                        <td><del>২৯ </del></td>
                                        <td><del>২৫৯.২৯ </del></td>
                                        <td><del>২৫৯.২৯ </del></td>
                                        <td><del>২৫৯.২৯ </del></td>
                 

                                    </tr>
                                    <tr>
                                        <td>১/১/২০২০</td>
                                        <td>৫</td>
                                        <td>২০০</td>
                                        <td>সাগর সৌরভ রায় </td>
                                        <td>৫৯.00 </td>
                                        <td></td>
                                        <td> </td>
                                        <td></td>
                                        <td> </td>
                                        <td> </td>
                                        <td> </td>
                                        <td> </td>
                                        <td></td>
                                        <td> </td>
                                        <td> </td>
                                        <td> </td>
                                        <td> </td>
                 

                                    </tr>
                                   
                                   
                                   
                                </tbody>
                                <tfoot>
                              
                                </tfoot>
                            </Table>

                                   

                                </div>
                                <div className="col-lg-12 col-md-12 pb-3">
                                    <div className="row">
                                        <div className="col-lg-6 col-md-6">
                                        <Button onClick={this.closeModal} className=" btn btn-outline-danger " variant="outline-danger">বন্ধ করুন </Button>
                                        </div>
       

                                    </div>
                                    
                                   

                                </div>


                            </div>
                        </div>
                    </div>
                </Modal>

            </div>
        )
    }
}

const mapStateToProps = state => ({
    customer: state.customer
})

export default connect(mapStateToProps)(ChengeHistoryModal);